import { DateValue } from '@internationalized/date';
import { RangeValue } from '@react-types/shared';
import { DateTime, Settings } from 'luxon';

import { Iso8601DateString } from 'lib/types';

// NB: If we only have one of the two dates, we'll default to a single day date range
export const getDateRange = (
  startDate?: Iso8601DateString,
  endDate?: Iso8601DateString,
): { start: Iso8601DateString; end: Iso8601DateString } => ({
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  start: DateTime.fromISO(startDate || endDate)
    .startOf('day')
    .toISO(),
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  end: DateTime.fromISO(endDate || startDate)
    .endOf('day')
    .toISO(),
});

export const getLuxonDateRange = (
  startDate: DateTime,
  endDate: DateTime,
): { start: Iso8601DateString; end: Iso8601DateString } => ({
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  start: startDate.startOf('day').toISO(),
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  end: (startDate || endDate).endOf('day').toISO(),
});
// Simply checks to see if the date is before 2018 or after today
const isDateOutOfBounds = (date: DateTime): boolean => {
  return date < DateTime.local(2018, 1, 1) || date > DateTime.local();
};

export const translateDateValuetoLuxon = (newDateRange: {
  start: DateValue;
  end: DateValue;
}): { startDate: Iso8601DateString; endDate: Iso8601DateString } => {
  const { start, end } = newDateRange;

  // Handle nulls
  if (start == null && end == null) {
    return {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      startDate: undefined,
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      endDate: undefined,
    };
  }

  // Months are one indexed, no need to adjust the date from CalendarDate <-> DateTime
  const startDate = DateTime.fromISO(start.toString(), { zone: Settings.defaultZone });
  const endDate = DateTime.fromISO(end.toString(), { zone: Settings.defaultZone });

  // Handle improper date inputs.
  // 1. Don't allow dates in the past
  // 2. Don't allow dates in the future
  // 3. Don't allow a start date after the end date
  // On improper input, reset
  if (isDateOutOfBounds(startDate) || isDateOutOfBounds(endDate) || startDate > endDate) {
    return {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      startDate: undefined,
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      endDate: undefined,
    };
  }

  //

  return {
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    startDate: startDate.toISO(),
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    endDate: endDate.toISO(),
  };
};

export const updateDateFilters = (
  newDateRange: RangeValue<DateValue> | null,
  handleDateUpdate: (newDateRange: {
    startDate: Iso8601DateString | undefined;
    endDate: Iso8601DateString | undefined;
  }) => void,
) => {
  if (newDateRange) {
    const { startDate, endDate } = translateDateValuetoLuxon(newDateRange);
    if (startDate || endDate) {
      handleDateUpdate({ startDate, endDate });
    }
  } else {
    handleDateUpdate({ startDate: undefined, endDate: undefined });
  }
};

export const updateDateUpdatedFilters = (
  newDateRange: RangeValue<DateValue> | null,
  handleDateUpdate: (newDateRange: {
    updatedAtStart: Iso8601DateString | undefined;
    updatedAtEnd: Iso8601DateString | undefined;
  }) => void,
) => {
  if (newDateRange) {
    const { startDate, endDate } = translateDateValuetoLuxon(newDateRange);
    if (startDate || endDate) {
      handleDateUpdate({ updatedAtStart: startDate, updatedAtEnd: endDate });
    }
  } else {
    handleDateUpdate({ updatedAtStart: undefined, updatedAtEnd: undefined });
  }
};
